import { Injectable } from '@angular/core';
import { SettingsApi } from '../api/api/SettingsApi';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class InfoBannersService {

  public banners: any = new BehaviorSubject({});

  constructor(private settingsApi: SettingsApi) {
    settingsApi.getAppBanners().subscribe(banners => {
      this.banners.next(banners);
    });
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/info-banners.service.ts